import * as Types from '../../graphql/generatedTypes';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type NextFreeEsInvoiceNumberQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type NextFreeEsInvoiceNumberQuery = { __typename?: 'Query', nextFreeEsInvoiceNumber: number };


export const NextFreeEsInvoiceNumberDocument = gql`
    query NextFreeEsInvoiceNumber {
  nextFreeEsInvoiceNumber
}
    `;

/**
 * __useNextFreeEsInvoiceNumberQuery__
 *
 * To run a query within a React component, call `useNextFreeEsInvoiceNumberQuery` and pass it any options that fit your needs.
 * When your component renders, `useNextFreeEsInvoiceNumberQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNextFreeEsInvoiceNumberQuery({
 *   variables: {
 *   },
 * });
 */
export function useNextFreeEsInvoiceNumberQuery(baseOptions?: Apollo.QueryHookOptions<NextFreeEsInvoiceNumberQuery, NextFreeEsInvoiceNumberQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<NextFreeEsInvoiceNumberQuery, NextFreeEsInvoiceNumberQueryVariables>(NextFreeEsInvoiceNumberDocument, options);
      }
export function useNextFreeEsInvoiceNumberLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<NextFreeEsInvoiceNumberQuery, NextFreeEsInvoiceNumberQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<NextFreeEsInvoiceNumberQuery, NextFreeEsInvoiceNumberQueryVariables>(NextFreeEsInvoiceNumberDocument, options);
        }
export type NextFreeEsInvoiceNumberQueryHookResult = ReturnType<typeof useNextFreeEsInvoiceNumberQuery>;
export type NextFreeEsInvoiceNumberLazyQueryHookResult = ReturnType<typeof useNextFreeEsInvoiceNumberLazyQuery>;
export type NextFreeEsInvoiceNumberQueryResult = Apollo.QueryResult<NextFreeEsInvoiceNumberQuery, NextFreeEsInvoiceNumberQueryVariables>;